import { FontFamily, typographyScale, TypographyVariant } from 'common/theme';

export const usePopupTypography = () => ({
    title: {
        fontSize: {
            xs: 18,
            sm: typographyScale[TypographyVariant.TitleSmall].fontSize,
            md: typographyScale[TypographyVariant.TitleMedium].fontSize,
        },
        lineHeight: {
            xs: 1.25,
            sm: typographyScale[TypographyVariant.TitleSmall].lineHeight,
            md: typographyScale[TypographyVariant.TitleMedium].lineHeight,
        },
        fontFamily: FontFamily.bold,
    },
    body: {
        fontSize: {
            xs: 15,
            sm: typographyScale[TypographyVariant.BodySmall].fontSize,
            md: typographyScale[TypographyVariant.BodyMedium].fontSize,
        },
        lineHeight: {
            xs: 1.35,
            sm: typographyScale[TypographyVariant.BodySmall].lineHeight,
            md: typographyScale[TypographyVariant.BodyMedium].lineHeight,
        },
    },
    action: {
        fontSize: {
            xs: 15,
            sm: typographyScale[TypographyVariant.LabelMedium].fontSize,
            md: typographyScale[TypographyVariant.LabelLarge].fontSize,
        },
        lineHeight: {
            xs: 1.35,
            sm: typographyScale[TypographyVariant.LabelMedium].lineHeight,
            md: typographyScale[TypographyVariant.LabelLarge].lineHeight,
        },
    },
});
